import { Component, OnChanges, OnInit } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'ups-select',
    template: `<div>
    <ngl-select [label]="to.label || ''" (change)="change(field)">
      <select ngl [required]="to.required || false" [formControl]="$any(formControl)">
        <option *ngFor="let item of to.options || $any([])" [value]="item.value">
          {{ item.label }}
        </option>
      </select>
    </ngl-select>
  </div>`,
    styleUrls: ['./select.type.component.scss'],
    standalone: false
})
export class SelectTypeComponent extends FieldType {
  public change(field?: FormlyFieldConfig): void {
    if (field?.templateOptions) {
      const selectedApiName: string = this.model[this.key.toString()];
      const options: { label: string; value: string; id: string }[] = this.to.options as any[];
      const option = options.find((option: any) => option.value === selectedApiName);

      if (field?.templateOptions && field.templateOptions['onChange']) {
        field.templateOptions['onChange'](this, option?.id, this.model, option);
      }

      if (field?.templateOptions && field?.templateOptions?.options && option) {
        if (option.hasOwnProperty('hiddenValue')) {
          this.model[`${this.field.key}Code`] = (option as any).hiddenValue;
        }
      }
    }
  }
}
